import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/thedesperatetrader/app/radar/AutoRefresh.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/thedesperatetrader/app/radar/RealtimePicksToggle.tsx");
;
import(/* webpackMode: "eager" */ "/opt/thedesperatetrader/node_modules/next/dist/client/link.js");
